/* @jsx h */
import { defineComponent, h } from "vue";
import { RouterView } from "vue-router";

import { PageComponent, useLocalization } from "@lemmonhq/uikit";
import { setTitle } from "@lemmonhq/orders";

export * from "./subpages/ProfileSettings";
export * from "./subpages/StaffSettings/index";
export * from "./subpages/PrintersSettings";
export * from "./subpages/Terminals";
export * from "./subpages/ConfigSettings";
export * from "./subpages/TaxSettings/index";
export * from "./subpages/ReservationSettings";
export * from "./subpages/AssetsSettings";
export * from "./subpages/PaymentsSettings";
export * from "./subpages/DiscountTypesSettings";
export * from "./subpages/AuditSettings";
export * from "./subpages/PrintTemplatesSettings";

export const ManagerSettingsPage = defineComponent({
  name: "ManagerSettingsPage",
  setup() {
    const { t } = useLocalization();
    setTitle("Settings");
    return () => {
      const subpages = [
        {
          name: t("settings.nav.title"),
          icon: "tune",
          href: "/app/settings",
        },
        {
          name: t("settings.nav.profile"),
          icon: "restaurant",
          href: "/app/settings/profile",
        },
        {
          name: t("settings.nav.reservations"),
          icon: "calendar_month",
          href: "/app/settings/reservations",
        },
        {
          name: t("settings.nav.assets"),
          icon: "perm_media",
          href: "/app/settings/assets",
        },
        {
          name: t("settings.discount_types_page.page_title"),
          icon: "local_offer",
          href: "/app/settings/discount-types",
        },
        {
          name: t("settings.nav.payments"),
          icon: "payment",
          href: "/app/settings/payments",
        },
        {
          name: t("settings.nav.terminals"),
          icon: "contactless",
          href: "/app/settings/terminals",
        },
        {
          name: "Print templates",
          icon: "receipt_long",
          href: "/app/settings/print-templates",
        },
        {
          name: "Audit",
          icon: "history",
          href: "/app/settings/audit",
        },
        ...(import.meta.env.VITE_ENV === "staging"
          ? [
              {
                name: t("settings.nav.staff"),
                icon: "group",
                href: "/app/settings/staff",
              },
              {
                name: t("settings.nav.taxes"),
                icon: "money",
                href: "/app/settings/taxes",
              },
            ]
          : []),
      ];
      return (
        <PageComponent
          title={t("settings.nav.page_title")}
          titleIcon="settings"
          subpages={subpages}
        >
          <RouterView />
        </PageComponent>
      );
    };
  },
});
